import { Component, OnInit } from '@angular/core';
import { ToastrService } from './services/toastr/toastr.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'crm';
  private battery: any; 
  batteryToastrVisible: boolean = false;
  constructor(private toastrService: ToastrService) {}

  ngOnInit() {
    this.toastrService.batteryToastrVisible$.subscribe(visible => {
      this.batteryToastrVisible = visible;
    });
    this.monitorBattery();
  }

  async monitorBattery() {
    if ('getBattery' in navigator) {
      this.battery = await (navigator as any).getBattery();

      this.battery.addEventListener('chargingchange', this.handleChargingChange);

      this.battery.addEventListener('levelchange', this.handleLevelChange);
    }
  }

  handleChargingChange = () => {
    if (this.battery.charging) {
       this.toastrService.showToast('Зарядка', 'Устройство подключено к зарядке', 'success', 'icon-battery_charging_20', 4000);
     } else {
       this.toastrService.showToast('Розрядка', 'Устройство отключено от зарядки', 'warning', 'icon-battery_1_bar', 4000);
     }
  }
  handleLevelChange = () => {
     if (this.battery.charging && this.battery.level == 0.8) {
        this.toastrService.showToast('Зарядка', 'Заряд достиг 80%', 'info', 'icon-battery_charging_80', 4000);
      }
      if (!this.battery.charging && this.battery.level == 0.2) {
        this.toastrService.showToast('Розрядка', 'Заряд достиг 20%', 'info', 'icon-battery_1_bar', 4000);
      }
      if (!this.battery.charging && this.battery.level == 0.05) {
        this.toastrService.showToast('Розрядка', 'Заряд достиг 5%. Подключите устройство к зарядке', 'warning', 'icon-battery_alert', 4000);
      }
      if (!this.battery.charging && this.battery.level == 0.01) {
        this.toastrService.showToast('Розрядка', 'Заряд достиг 1%. Подключите устройство к зарядке', 'warning', 'icon-battery_error', 4000);
      }
  }
  ngOnDestroy() {
    if (this.battery) {
      this.battery.removeEventListener('chargingchange', this.handleChargingChange);
      this.battery.removeEventListener('levelchange', this.handleLevelChange);
    }
  }
}
